import { Box, Typography, useTheme } from '@mui/material';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { dataTestIds } from 'src/constants/data-test-ids';
import { NoteDTO } from 'utils';
import { AssessmentTitle } from '../../../../../../components/AssessmentTitle';
import { useChartData } from '../../../stores/appointment/appointment.store';

export const MedicalConditionsContainer: FC<{ notes?: NoteDTO[] }> = ({ notes }) => {
  const { chartData } = useChartData();
  const theme = useTheme();
  const { t } = useTranslation();
  const conditions = chartData?.conditions?.filter((condition) => condition.current === true);

  return (
    <Box
      sx={{ display: 'flex', flexDirection: 'column', gap: 0.5, width: '100%' }}
      data-testid={dataTestIds.progressNotePage.medicalConditionsContainer}
    >
      <Typography variant="h5" color="primary.dark">
        {t('telemed.review.medicalConditions.title')}
      </Typography>
      {conditions?.length ? (
        conditions?.map((condition) => (
          <Typography key={condition.resourceId}>
            {condition.display} {condition.code}
          </Typography>
        ))
      ) : (
        <Typography color={theme.palette.text.secondary}>{t('telemed.review.medicalConditions.noData')}</Typography>
      )}

      {notes && notes.length > 0 && (
        <>
          <AssessmentTitle>{t('telemed.review.medicalConditions.notes')}</AssessmentTitle>
          <Box sx={{ display: 'flex', flexDirection: 'column', gap: 0.5 }}>
            {notes?.map((note) => (
              <Typography key={note.resourceId}>{note.text}</Typography>
            ))}
          </Box>
        </>
      )}
    </Box>
  );
};
